module.exports = __webpack_public_path__ + "img/images_marketing_bg2.e181fd20.png";